// removed by extract-text-webpack-plugin
module.exports = {"HomeItemListItem":"Kx1fkzZQ-xsAsCHugDdfT","HomeItemListSubItem":"_1P5WhmQkhP04tV0wn5gZHj","liveroom":"_8asCfmhyt2FpiDr6D78mu","photo":"_1mEjARnhf7W1-Yt1G5nSfg","text":"_3lruTe_S-LJQJpgczcpKtT"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeItemListItem/index.module.less
// module id = 429
// module chunks = 0